import Typography, { type TypographyProps } from "@mui/material/Typography";
import { styled } from "../../../../lib/styled";

const FinePrintText = styled(Typography)({ fontSize: "0.6875rem", lineHeight: 1.45 });

/** The smallest muted text, for legal and disclaimer copy that should stay out of the way. */
export function FinePrint(props: TypographyProps) {
  return <FinePrintText variant="caption" color="text.secondary" {...props} />;
}
